import { Box, Typography } from '@mui/material';
import { useArchivedSlideViewStyles } from 'components/common/ArchivedSlideView/styles';

export const ArchivedSlideView = ({ slide }) => {
  const { classes } = useArchivedSlideViewStyles();

  return (
    <Box className={classes.container}>
      <Typography align="center" display="flex" flexDirection="row">
        <Box color="red" minWidth={20} marginRight={1}>
          [ ! ]
        </Box>
        You are viewing an archived slide. This is a static screenshot of the
        original WSI, and certain features may be unavailable.
      </Typography>
      <Box className={classes.thumbnailContainer}>
        <img
          src={slide?.large_thumbnail_url}
          alt="slide-thumbnail"
          className={classes.thumbnail}
        />
      </Box>
    </Box>
  );
};
